import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RequestItem, useOptionsApi } from '@innowise-group/core';
import { InfoTooltip } from '@shared-components';
import { LabeledCheckbox } from '@shared-mui-components';

import { RequestFormViewProps } from '../../request-form.types';
import * as Styled from './conditions-section.styles';

type ConditionsSectionProps = Pick<RequestFormViewProps, 'disabled' | 'isEdit' | 'isHiringManager'>;

const ConditionsSection: React.FC<ConditionsSectionProps> = ({ disabled, isEdit, isHiringManager }) => {
  const { t } = useTranslation();
  const { workloadsOptions, workFormatsOptions, employmentFormsOptions } = useOptionsApi();
  const { control } = useFormContext<RequestItem>();

  return (
    <Styled.ConditionsContainer>
      <Styled.FieldsGroup>
        <Styled.GroupLabel>{t('pages.candidates.candidateDetails.employmentType')}</Styled.GroupLabel>
        {workloadsOptions?.map((item, index) => (
          <Controller
            name={`workloads.${index}.checked`}
            control={control}
            key={item.value}
            render={({ field: { value, onChange } }) => (
              <LabeledCheckbox disabled={disabled} onChange={onChange} checked={value} label={item.title} />
            )}
          />
        ))}
      </Styled.FieldsGroup>
      <Styled.FieldsGroup>
        <Styled.GroupLabel>{t('pages.candidates.candidateDetails.formatOfWork')}</Styled.GroupLabel>
        {workFormatsOptions?.map((item, index) => (
          <Controller
            name={`workFormats.${index}.checked`}
            control={control}
            key={item.value}
            render={({ field: { value, onChange } }) => (
              <LabeledCheckbox disabled={disabled} onChange={onChange} checked={value} label={item.title} />
            )}
          />
        ))}
      </Styled.FieldsGroup>
      <Styled.FieldsGroup>
        <Styled.LabelWithIconWrapper>
          <Styled.GroupLabel>{t('pages.requests.viewModal.formOfEmployment')}</Styled.GroupLabel>
          <InfoTooltip title={t('tooltips.formOfEmploymentDescription')} placement="top" />
        </Styled.LabelWithIconWrapper>
        {employmentFormsOptions?.map((item, index) => (
          <Controller
            name={`employmentForms.${index}.checked`}
            control={control}
            key={item.value}
            render={({ field: { value, onChange } }) => (
              <LabeledCheckbox
                disabled={disabled || (isHiringManager && isEdit)}
                onChange={onChange}
                checked={value}
                label={item.title}
              />
            )}
          />
        ))}
      </Styled.FieldsGroup>
    </Styled.ConditionsContainer>
  );
};

export default ConditionsSection;
